export const NAME_RULE = /\p{L}/u
export const hasLetter = (value) => typeof value === 'string' && NAME_RULE.test(value)
